import { render, staticRenderFns } from "./BuyOrSellBusiness.vue?vue&type=template&id=0d86331b&scoped=true&"
import script from "./BuyOrSellBusiness.vue?vue&type=script&lang=js&"
export * from "./BuyOrSellBusiness.vue?vue&type=script&lang=js&"
import style0 from "./BuyOrSellBusiness.vue?vue&type=style&index=0&id=0d86331b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d86331b",
  null
  
)

export default component.exports